document.addEventListener('DOMContentLoaded', () => {

    const header = document.querySelector('x-header.header'); 
    const headerParent = document.querySelector('header'); 
    const logo = document.querySelector('.header__logo-image'); 

    if (!header || !logo) {
        console.warn('Header o logo no encontrados');
        return;
    }

    function isPureWhite(color) {
        return (
            color === 'rgb(255, 255, 255)' ||
            color === 'rgba(255, 255, 255, 1)'
        );
    }

    function updateLogo() {
        const bg = window.getComputedStyle(header).backgroundColor;

        if (isPureWhite(bg)) {
            logo.style.filter = 'brightness(0)';   // Poner logo negro
        } else {
            logo.style.filter = '';                // Logo normal
        }
    }

    // Scroll con timeout igual que arriba
    window.addEventListener('scroll', () => {
        setTimeout(() => {
            updateLogo();
        }, 300);
    });

    header.addEventListener('mouseenter', () => {
        setTimeout(() => {
            updateLogo();
        }, 300);
    });

    header.addEventListener('mouseleave', () => {
        setTimeout(() => {
            updateLogo();
        }, 300);
    });

    updateLogo();
});